import { Link } from 'react-router-dom';
import { useGallery } from '../api/queries';
import { MediaImage } from '../components/ui';

/** Four-up strip of gallery images above the footer, linking through to the gallery. */
export function GalleryStripBlock({ data }: { data: { limit?: number } }) {
  const { data: gallery, isLoading } = useGallery();
  const items = (gallery ?? []).filter((item) => item.showOnHome).slice(0, data.limit ?? 8);

  if (isLoading) {
    return (
      <section className="sz-gallery-strip" aria-hidden="true">
        {Array.from({ length: data.limit ?? 8 }).map((_, index) => (
          <div key={index} className="sz-skeleton" style={{ height: 220 }} />
        ))}
      </section>
    );
  }

  if (items.length === 0) return null;

  return (
    <section className="sz-gallery-strip" aria-label="Gallery preview">
      {items.map((item) => (
        <Link key={item.id} to="/gallery" aria-label={`Gallery — ${item.title}`}>
          <MediaImage
            media={item.image}
            alt={item.title}
            className="sz-gallery-strip__item"
            placeholder={item.category}
            zoomOnHover
            sizes="25vw"
          />
        </Link>
      ))}
    </section>
  );
}

/**
 * Social grid. The handle and images come from the CMS gallery rather than a live
 * Instagram feed: no Instagram credentials are configured, and showing CMS images is
 * honest about that rather than implying a live feed.
 */
export function InstagramGridBlock({ data }: { data: { handle?: string; limit?: number } }) {
  const { data: gallery } = useGallery();
  const items = (gallery ?? []).slice(0, data.limit ?? 5);
  if (items.length === 0) return null;

  return (
    <section className="sz-instagram" aria-label="Social gallery">
      <p className="sz-eyebrow">{data.handle ?? '@SAZERAC'}</p>
      <div className="sz-instagram__grid">
        {items.map((item) => (
          <MediaImage
            key={item.id}
            media={item.image}
            alt={item.title}
            className="sz-instagram__item"
            placeholder="IG"
            zoomOnHover
            sizes="20vw"
          />
        ))}
      </div>
    </section>
  );
}
